import Link from 'next/link';
import { Box, Flex, Heading, Text, Stack, useColorModeValue as mode } from '@chakra-ui/react';
import DashboardCard from '@components/atoms/DashboardCard';
import doctorIcon from '@public/flaticons/doctor.png';
import CardHeading from './CardHeading';

function MedigapDashboardCard({ activePlan, futurePlan, title }) {
  const benefitsLink = (plan) => {
    const plans = ['G', 'N', 'F'];
    if (plans.includes(plan?.name)) {
      return (
        <Heading display="inline-block" pl={[0, 0, 10, 10, 10]} fontSize="lg" mb="3">
          <Link href="/account/medigap-benefits" id="medigap-benefits-link">
            <Text textDecoration="underline" color={mode('blue.500', 'blue.200')}>
              See Plan Details
            </Text>
          </Link>
        </Heading>
      );
    }
    return null;
  };

  // formats cleanly to UTC
  function formatDate(effective_date) {
    const date = new Date(effective_date);
    const month = date.getUTCMonth() + 1;
    const day = date.getUTCDate();
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
  }

  function formatPlanName(plan) {
    if (plan.name === 'Basic w/Riders' || plan.name === 'Basic' || plan.name === 'Extended Basic') {
      return `${plan.carrier_name} ${plan.name || ''}`;
    }
    return `${plan.carrier_name} Plan ${plan.name || ''}`;
  }

  return (
    <DashboardCard>
      <Stack textAlign="left" h="max-content">
        <CardHeading title={title} src={doctorIcon} alt="stethescope" />
        {activePlan ? (
          <Box>
            <Heading fontSize="lg" mb={2}>
              Current Coverage
            </Heading>
            <Flex flexDir={['column', 'column', 'row', 'row', 'row']}>
              <Heading fontSize="lg" mb="3" fontWeight="normal">
                {formatPlanName(activePlan)}
              </Heading>
              {benefitsLink(activePlan)}
              <Heading display="inline-block" pl={[0, 0, 10, 10, 10]} fontSize="lg" mb="3" />
            </Flex>
          </Box>
        ) : null}
        {futurePlan ? (
          <Box>
            <Heading fontSize="lg" mb="2">
              Future Coverage - Effective {formatDate(futurePlan.effective_date)}
            </Heading>
            <Flex flexDir={['column', 'column', 'row', 'row', 'row']}>
              <Heading fontSize="lg" mb="3" fontWeight="normal" display="inline-block">
                {formatPlanName(futurePlan)}
              </Heading>
              {benefitsLink(futurePlan)}
            </Flex>
          </Box>
        ) : null}
      </Stack>
    </DashboardCard>
  );
}

export default MedigapDashboardCard;
